<template>
	<layout :active.sync="active" v-bind="{title, name: title, selector: true}" @select="close">
		<template slot="fields">
			fields
		</template>
	</layout>
</template>

<script>
import layout from "./layout.vue";

export default {
	components: {layout},
	data() {
		return {
			active: false,
			title: "Vælg produkt"
		}
	},
	methods: {
		close() {
			this.$emit("close");
		}
	}
};
</script>
